import React from 'react';

import './style.scss';

const Bubble = ({ forwardRef, color, className }) => (
  <div ref={forwardRef} className={`Bubble ${className}`}>
    {className && (
      <style>
        {`.Bubble.${className} { background-color: #${color};}`}
      </style>
    )}
  </div>
);

export default Bubble;
